import { BaseEditor, Editor, Range } from 'slate'

/**
 * If some text is inserted while the cursor is at end or at the start of the text node having the
 * inline properties, the marks of the inline properties will not be carried forward to the new inserted text.
 */
export function stopAddingInlineProperties(editor: BaseEditor) {
  if (!editor.selection) return
  if (Range.isExpanded(editor.selection)) return

  const leaf = Editor.leaf(editor, editor.selection)

  if (!leaf) return

  const [leafNode, leafPath] = leaf
  if (!('id' in leafNode) && !('classname' in leafNode)) return

  const isAtEdge = Editor.isEdge(editor, editor.selection.focus, leafPath)
  if (!isAtEdge) return

  ;['id', 'classname'].forEach((mark) => Editor.removeMark(editor, mark))
}
